import { isCollectorCategory, type AddCategory } from "@kovernow/flows/add_item";
import { ChevronRight } from "lucide-react";
import { categoryIcon } from "../../components/category-icons";
import { useT } from "../../core/use-t";
import { STEP_HEADING_ID, StepHeading, type StepProps } from "./shared";

/** Step 1: the tenant's categories (legacy and enabled collectors), in tile order. */
export function CategoryStep({
  categories,
  goTo,
  headingRef,
}: Pick<StepProps, "goTo" | "headingRef"> & { categories: AddCategory[] }) {
  const t = useT();
  return (
    <section aria-labelledby={STEP_HEADING_ID} className="flex flex-col gap-4" data-testid="step-category">
      <StepHeading headingRef={headingRef}>{t("addItem.category.title")}</StepHeading>
      <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" aria-label={t("addItem.category.legend")}>
        {categories.map((c) => {
          const Icon = categoryIcon(c);
          return (
            <li key={c}>
              <button
                type="button"
                data-testid={`category-${c}`}
                onClick={() => goTo(isCollectorCategory(c) ? "info" : "search", c)}
                className="flex min-h-14 w-full items-center gap-3 rounded-lg border px-4 text-left font-semibold hover:bg-muted focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none"
              >
                <Icon aria-hidden="true" className="size-6 shrink-0 text-primary" />
                <span className="flex-1">{t(`home.tiles.${c}`)}</span>
                <ChevronRight aria-hidden="true" className="size-5 shrink-0" />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
